import {BaseContainerModel} from '../../base-container.model';
import {bl_crm_contact_key_target_link_RowClass} from '../../../dbschema/bl_crm_contact_key_target_links.model';


export class ContactKeyTargetLinkContainerModel extends BaseContainerModel {
  bl_crm_contact_key_target_link: bl_crm_contact_key_target_link_RowClass = new bl_crm_contact_key_target_link_RowClass();
}
